module.exports = __webpack_public_path__ + "media/images/customer-04382e9f61232f9378cbd4f0e370b84e.svg";